module.exports = __webpack_public_path__ + "static/media/tanar-vagyok.846a76d4.png";